<template>

    <div>
        <form class="myForm mt-5">

            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Contrato:<span class="text-danger">*</span></label>
                    <div class="col-sm-10">
                        <multiselect v-model="value" :options="op" select-label="" deselect-label="X" selectedLabel="" :custom-label="nameWithLang" placeholder="Selecione por contrato, unidade, fornecedor ou tipo de fornecimento" label="contrato" track-by="contrato" @input="function(value) {uid = value.code; mostraEnder(uid) }"><span slot="noResult" class="text-info">Nenhum dado encontrado</span></multiselect>
                    </div>

            </div>

            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Unidade:</label>
                <div class="col-sm-10">
                    <input class="form-control" type="text" v-model="unidade" disabled>
                </div>
            </div>

             <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Logradouro:</label>
                <div class="col-sm-4">
                    <input class="form-control" type="text" v-model="logradouro" disabled>
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Bairro:</label>
                <div class="col-sm-4">
                    <input class="form-control" type="text" v-model="bairro" disabled>
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Cidade:</label>
                <div class="col-sm-4">
                    <input class="form-control" type="text" v-model="cidade" disabled>
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Estado:</label>
                <div class="col-sm-4">
                    <input class="form-control" type="text" v-model="estado" disabled>
                </div>
            </div>

            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">CEP:</label>
                <div class="col-sm-4">
                    <input class="form-control" type="text" v-model="cep" disabled>
                </div>
                <label for="nome" class="col-sm-2 col-form-label">
                    Ano Ref.:
                    <span class="text-danger">*</span>
                </label>
                <div class="col-sm-4">
                    <multiselect
                            v-model="ano"
                            tag-placeholder="Selecione"
                            placeholder="Ano Ref."
                            label
                            track-by
                            select-label=""
                            deselect-label="X"
                            selectedLabel=""
                            :options="optionsAno"
                    >
                        <span slot="noResult" class="text-info">Ano não encontrado</span>
                    </multiselect>

                </div>
            </div>

            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">
                    Mês Ref.:
                    <span class="text-danger">*</span>
                </label>
                <div class="col-sm-4">
                    <multiselect
                            v-model="mes"
                            tag-placeholder="Selecione"
                            placeholder="Mes Ref."
                            label
                            track-by
                            select-label=""
                            deselect-label="X"
                            selectedLabel=""
                            :options="optionsMes"
                            @input="validaData('mes')"
                    >
                        <span slot="noResult" class="text-info">Mês não encontrado</span>
                    </multiselect>
                </div>
            <label for="nome" class="col-sm-2 col-form-label">
                    Data de Vencimento:
                    <span class="text-danger">*</span>
                </label>
                <div class="col-sm-4">
                    <input type="date" class="form-control" @change="validaData('dtVencimento')" v-model="dtVencimento">
                </div>

            </div>

            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Consumo:<span class="text-danger">*</span></label>
                <div class="col-sm-4">
                    <the-mask type="text" mask="############" class="form-control" v-model="consumo" ></the-mask>
                </div>
                 <label for="nome" class="col-sm-2 col-form-label">Valor Conta(R$):<span
                        class="text-danger">*</span></label>
                <div class="col-sm-4">
                    <money class="form-control" v-bind="money" v-model="valorConta"></money>
                </div>
            </div>
        </form>
        <div class="container text-right mt-2">
            <button class="btn btn-sm btn-danger" @click="retorno">Retornar</button>
            <button class="btn btn-sm btn-success ml-2"
                    :disabled="(!mes != '' || !ano != '' || !dtVencimento != '' || !valorConta != '' || !consumo != '' || !value != '')"
                    @click="salvar">Salvar
            </button>
        </div>
    </div>

</template>


<script>
import Multiselect from 'vue-multiselect'

    export default {
        name: 'CadastroContasEditar',
        props: {
            id: Number
        },
        data() {
            return {
                mes: '',
                ano: '',
                dtVencimento: '',
                consumo: '',
                valorConta: '',
                cep: '',
                unidade: '',
                logradouro: '',
                bairro: '',
                cidade: '',
                estado: '',
                cep: '',
                value: [],
                op: [],
                uid: '',
                idContrato: '',
                optionsMes: [],
                optionsAno: [],
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ '
                }
            }
        },
        methods: {
            retorno() {
                this.$router.go(0)
            },
            validaData(model) {
                let mesAnos = this.dtVencimento.split('-',2)
                let valorMes = parseInt(mesAnos[1])
                let valorAno = parseInt(mesAnos[0])

                if(this.mes > valorMes || this.ano > valorAno){
                    this.$swal('Atenção!', 'A data de vencimento não pode ser antes da data de referência', 'warning')
                    this[model] = ''

                }
            },
            salvar() {
                api.enviarRequisicao('put', '/api/contas-consumo/cadastro-contas/' + this.id, {
                    ba03_mes_ref: this.mes,
                    ba03_ano_ref: this.ano,
                    ba03_dt_vencimento: this.dtVencimento,
                    ba03_consumo: this.consumo,
                    ba03_valor_conta: this.valorConta,
                    ba03_contrato_id: this.uid
                }).then(response => {
                    this.$swal('Atenção!', 'Dados salvos com sucesso.', 'success')
                        .then(
                            function () {
                                history.go(0);
                            }
                        )
                })
                .catch(function (error) {
                    this.$swal('Atenção!', 'Erro ao cadastrar os dados.', 'error')
                })
            },
            nameWithLang ({ contrato, unidade, fornecedor, tipoForn }) {
                return 'Contrato: '+`${contrato} — ${unidade} — ${fornecedor} — ${tipoForn}`
            },
            mostraEnder(uid){
                api.enviarRequisicao('get', '/api/contas-consumo/cadastro-contas/pre-store/'+uid)
                .then(response => {
                    this.unidade = response.data[0][0].ba02_unidade,
                    this.logradouro = response.data[1][0].ba01_logradouro,
                    this.bairro = response.data[1][0].ba01_bairro,
                    this.cidade = response.data[1][0].ba01_cidade,
                    this.estado = response.data[1][0].ba01_estado,
                    this.cep = response.data[1][0].ba01_cep
                })
            }
        },
        components: {
            Multiselect
        },
        mounted: function () {
            api.enviarRequisicao('get', '/api/contas-consumo/cadastro-contas/'+this.id)
            .then(response => {
                this.mes = response.data[0].ba03_mes_ref,
                this.ano = response.data[0].ba03_ano_ref,
                this.dtVencimento = response.data[0].ba03_dt_vencimento,
                this.consumo = response.data[0].ba03_consumo,
                this.valorConta = response.data[0].ba03_valor_conta,
                this.logradouro = response.data[0].ba01_logradouro,
                this.bairro = response.data[0].ba01_bairro,
                this.cidade = response.data[0].ba01_cidade,
                this.cep = response.data[0].ba01_cep,
                this.estado = response.data[0].ba01_estado,
                this.unidade = response.data[0].ba02_unidade,
                this.idContrato = response.data[0].ba04_id
                this.uid = response.data[0].ba04_id

                api.enviarRequisicao('get', '/api/contas-consumo/cadastro-contas/pre-edit/'+this.idContrato)
                .then(response => {
                    this.value.push({contrato: response.data[0][0].ba04_numero, unidade: response.data[0][0].ba02_unidade, fornecedor: response.data[0][0].ba00_fornecedor, tipoForn: response.data[0][0].tp01_descricao })
                })
            })

            api.enviarRequisicao('get', '/api/contas-consumo/cadastro-contas/create')
            .then(response => {
                for(var i = 0; i < response.data.length; i++){
                    this.op.push({ contrato: response.data[i].ba04_numero, unidade: response.data[i].ba02_unidade, fornecedor: response.data[i].ba00_fornecedor, tipoForn: response.data[i].tp01_descricao, code: response.data[i].ba04_id})
                }
            })

            let i = 2000;
            let mes = 1;
            let anosCombo = [];
            while (new Date().getFullYear() >= i) {
            anosCombo.push(i);
            i++;
            }
            this.optionsAno = anosCombo.slice().reverse();

            while (mes <= 12) {
            this.optionsMes.push(mes);
            mes++;
            }
                }

    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
    .salvar {
        background-color: #18A689;
        color: #fff;
        font-size: 12px;
        text-decoration: none;
    }

</style>
